export default __webpack_public_path__ + "static/media/bjsh-code-base-large.8e50e934.jpg";